import React from "react"

// import Auth from "auth";
import { API } from "API"
import { ErrorsCallback, SuccessConfirm } from "alertService"
import * as Alert from "alertService"

// @material-ui/core components =====
import withStyles from "@material-ui/core/styles/withStyles"

// @material-ui/icons =====
import AddCircleIcon from "@material-ui/icons/AddCircle";
import FormatListNumberedIcon from "@material-ui/icons/FormatListNumbered";
import EditIcon from "@material-ui/icons/Edit";
// import DeleteForeverIcons from "@material-ui/icons/DeleteForever";
// import Check from "@material-ui/icons/Check";

// core components =====
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem"
import NavPills from "components/NavPills/NavPills";

// ComponentsPage =====
import ListsPage from "./Lists";
import CreatePage from "./Create";

import { cardTitle } from "assets/jss/material-dashboard-pro-react"
// import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle"
const styles = {
  ...regularFormsStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  mt4: {
    marginTop: "30px"
  },
  titleIcon: {
    marginBottom: -7

  }
}
class ProjectManagementPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      currentPage: 0,
      currentData: null,
    }
  }

  componentDidMount() {
    Alert.Loading(true)
  }
  
  setTabIndex = (index,callback) => {
    var inv = setTimeout(() => {
      clearInterval(inv)
      this.setState({currentPage:index},()=>{
        if(index === 0){
          this.setState({currentData:null},()=>{
            if(callback)callback()
          })
        }else{
          if(callback)callback()
        }
      })
    }, 150);
  }

  getTabIndex = (index) => {
    console.log("getTabIndex >>",index)
    if(index === 0){
      this.setState({currentData:null},()=>{
        if(this.state.currentPage !== 0){
          var inv = setTimeout(() => {
            clearInterval(inv)
            this.setState({currentPage:0})
          }, 100);
        }
      })
    }
  }

  setcurrentData = (dataObject) => {
    this.setState({currentData:dataObject})
  }
  render() {
    const { classes } = this.props

    return (
      <GridContainer>
        <GridItem xs={12}>
          <NavPills
            onChangeTabIndex={this.getTabIndex}
            color="info"
            active={this.state.currentPage}
            tabs={[
              {
                // <GroupIcon className={classes.titleIcon} /> 
                tabIcon: FormatListNumberedIcon,
                tabButton: "รายการ",
                tabContent: <ListsPage 
                              callbacksetTabIndex = {this.setTabIndex} 
                              callbackSetCurrentData = {this.setcurrentData}
                            />
              },
              {
                tabIcon: ((this.state.currentData)?EditIcon:AddCircleIcon),
                tabButton: ((this.state.currentData)?"แก้ไขข้อมูล":"สร้างใหม่"),
                tabContent: <CreatePage 
                              currentData={this.state.currentData}
                              callbacksetTabIndex = {this.setTabIndex} 
                            />
              }
            ]}
          />
        </GridItem>
      </GridContainer>
    )
  }
}

export default withStyles(styles)(ProjectManagementPage)
